import { Base } from "ui/Scripts/source/framework/base";
import { IUserListItemUserGroup, UserListItemUserGroup } from "./userListItemUserGroup";

export interface IUserListItem {
    id: string;
    code: string;
    firstName: string;
    lastName: string;
    picture: string;
    defaultPictureInUse: boolean;
    email: string;
    comment: string;
    endDate: number;
    defaultCulture: string;
    pushNotificationType: number;
    emailNotificationType: number;
    recordEmailNotificationType: number;
    recordEmailNotificationShowExpired: boolean;
    instantMessageUserInvitationAcceptType: number;
    hasRecordUser: boolean;
    hasActiveRecordUser: boolean;
    mobileInUse: boolean;
    mobileActive: boolean;
    webActive: boolean;
    hasLoggedIn: boolean;
    microsoftAccount: boolean;
    disabled: boolean;
    userGroups: IUserListItemUserGroup[];

    userGroupsStr: string;
    getName(): string;
}

export class UserListItem implements IUserListItem {
    id: string;
    code: string;
    firstName: string;
    lastName: string;
    picture: string;
    defaultPictureInUse: boolean;
    email: string;
    comment: string;
    endDate: number;
    defaultCulture: string;
    pushNotificationType: number;
    emailNotificationType: number;
    recordEmailNotificationType: number;
    recordEmailNotificationShowExpired: boolean;
    instantMessageUserInvitationAcceptType: number;
    hasRecordUser: boolean;
    hasActiveRecordUser: boolean;
    mobileInUse: boolean;
    mobileActive: boolean;
    webActive: boolean;
    hasLoggedIn: boolean;
    microsoftAccount: boolean;
    disabled: boolean;
    userGroups: UserListItemUserGroup[];
    
    userGroupsStr: string;

    constructor();
    constructor(obj: IUserListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.firstName = obj && obj.firstName || "";
        this.lastName = obj && obj.lastName || "";
        this.picture = obj && obj.picture || "";
        this.defaultPictureInUse = obj && obj.defaultPictureInUse || false;
        this.email = obj && obj.email || "";
        this.comment = obj && obj.comment || "";
        this.endDate = obj && obj.endDate || 0;
        this.defaultCulture = obj && obj.defaultCulture || "";
        this.pushNotificationType = obj && obj.pushNotificationType || 0;
        this.emailNotificationType = obj && obj.emailNotificationType || 0;
        this.recordEmailNotificationType = obj && obj.recordEmailNotificationType || 0;
        this.recordEmailNotificationShowExpired = obj && obj.recordEmailNotificationShowExpired || false;
        this.instantMessageUserInvitationAcceptType = obj && obj.instantMessageUserInvitationAcceptType || 0;
        this.hasRecordUser = obj && obj.hasRecordUser || false;
        this.hasActiveRecordUser = obj && obj.hasActiveRecordUser || false;
        this.mobileInUse = obj && obj.mobileInUse || false;
        this.mobileActive = obj && obj.mobileActive || false;
        this.webActive = obj && obj.webActive || false;
        this.hasLoggedIn = obj && obj.hasLoggedIn || false;
        this.microsoftAccount = obj && obj.microsoftAccount || false;
        this.disabled = obj && obj.disabled || false;
        this.userGroups = Base.getTypedArray(obj ? obj.userGroups : null, UserListItemUserGroup);
        this.userGroupsStr = Base.getStringWithSeparators(this.userGroups.map(i => i.name + (i.companyName ? ` (${i.companyName})` : "")), ", ");
    }

    getName(): string {
        return ((this.lastName ?? "") + " " + (this.firstName ?? "")).trim();
    }
        
    static sortUserListItems(items: IUserListItem[], column: string, asc: boolean): IUserListItem[] {
        if (!items && items.length < 2) return items;
        if (column === "name") {
            return items.sort((a: IUserListItem, b: IUserListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.getName(), b.getName())); });
        } else if (column === "code") {
            return items.sort((a: IUserListItem, b: IUserListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.code, b.code)); });
        } else if (column === "comment") {
            return items.sort((a: IUserListItem, b: IUserListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.comment, b.comment)); });
        } else {
            return items.sort((a: IUserListItem, b: IUserListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.userGroupsStr, b.userGroupsStr)); });
        }
    }
}